import gql from 'graphql-tag';

import type {
  QualifyingWorkspace,
  WorkflowCardItem
} from '@/components/userDashboard/workflowsCards/workspaceFilterMatch';

// Uses graphql-tag (untyped document) + explicit result types below rather than the
// codegen `@/apollo` gql tag: `pnpm graph` is broken at baseline (duplicate
// `PriorityFragment` defined in existing test files), and this matches the graphql-tag
// pattern already used across trace-ui (dashboard query, subscriptionsMenu, mutations).
export const WORKFLOW_CARDS_DASHBOARD_QUERY = gql`
  query WorkflowCardsDashboardQuery {
    workflows(filter: { draft: { equalTo: false } }) {
      totalCount
      nodes {
        rowId
        canUpdate
        name
        description
        settings
        actions {
          nodes {
            key
            title
          }
        }
        traces: tracesDeprecated {
          totalCount
        }
        groups {
          totalCount
          nodes {
            rowId
            name
            avatar
            canActQuick
          }
        }
        documentation {
          url
          file {
            name
            size
            digest
          }
        }
        workspace {
          rowId
          name
          color
          version
          workspaceCreatedBy
          workspaceUpdatedAt
        }
      }
    }
  }
`;

export type WorkflowCardsDashboardResult = {
  workflows: {
    totalCount: number;
    nodes: WorkflowCardItem[];
  } | null;
};

export const WORKSPACE_FOR_WORKFLOW_QUERY = gql`
  query WorkspaceForWorkflowQuery($workflowId: BigInt!) {
    workflowByRowId(rowId: $workflowId) {
      rowId
      workspace {
        rowId
        name
        color
        version
      }
    }
  }
`;

export type WorkspaceForWorkflowResult = {
  workflowByRowId: {
    rowId: string;
    workspace: QualifyingWorkspace | null;
  } | null;
};

export const WORKSPACE_FOR_GROUP_QUERY = gql`
  query WorkspaceForGroupQuery($groupId: BigInt!) {
    groupByRowId(rowId: $groupId) {
      rowId
      workflow {
        rowId
        workspace {
          rowId
          name
          color
          version
        }
      }
    }
  }
`;

export type WorkspaceForGroupResult = {
  groupByRowId: {
    rowId: string;
    workflow: {
      rowId: string;
      workspace: QualifyingWorkspace | null;
    } | null;
  } | null;
};

export const WORKSPACE_FOR_TRACE_QUERY = gql`
  query WorkspaceForTraceQuery($traceId: UUID!) {
    traceById(id: $traceId) {
      rowId
      workflow {
        rowId
        workspace {
          rowId
          name
          color
          version
        }
      }
    }
  }
`;

export type WorkspaceForTraceResult = {
  traceById: {
    rowId: string;
    workflow: {
      rowId: string;
      workspace: QualifyingWorkspace | null;
    } | null;
  } | null;
};

// Cheap, access-respecting check for "does this user have any workspace?".
// PostGraphile only returns workspaces the user can see, so totalCount > 0
// means the user has workspace access.
export const HAS_WORKSPACES_QUERY = gql`
  query HasWorkspacesQuery {
    workspaces(first: 1) {
      totalCount
    }
  }
`;

export type HasWorkspacesResult = {
  workspaces: {
    totalCount: number;
  } | null;
};
